export default __webpack_public_path__ + "static/media/starLinks.98f289bd.csv";